import { useRouter } from 'next/router';
import { useMemo } from 'react';

export const useGatsbyLikeLocation = () => {
  const router = useRouter();

  return useMemo(() => {
    const hasSearch = router.asPath.indexOf('?');

    return {
      pathname: router.pathname,
      search: !~hasSearch ? '' : router.asPath.substring(hasSearch),
      query: router.query,
    };
  }, [router]);
};
